import { render } from "./ListItem.vue?vue&type=template&id=1a797efc&scoped=true"
const script = {}

import "./ListItem.vue?vue&type=style&index=0&id=1a797efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a797efc"]])

export default __exports__